import CategoryIcons from './CategoryIcons';

export default CategoryIcons;
